import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import globalNotification from 'live/services/global-notification'
import { StyledCardContainer, Table, HeadRow, BodyRow, StyledEmptyData } from '../styles/styles'
import { OrderingHeader } from 'live/components/ui/List'
import dateService from 'live/services/date'
import { canManageMetadata } from '../../permission/Permissions'

interface Props {
    data: Changes
    selected: {
        asset: {
            id: string
            name: string
        }
    }
    type: string
}

const ChangeLog: React.FC<Props> = ({ data, selected: currentAsset, type }: Props) => {
    const [collapsed, setCollapsed] = useState(false)
    const handleDelete = (wellboreId: string, id: string, key: string, type: string): void => {
        fetch(
            `services/plugin-asset-metadata/changeLog/${type}?wellboreId=${wellboreId}&interventionId=${id}&key=${key}`,
            {
                method: 'DELETE'
            }
        )
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok')
                }
            })
            .then(() => globalNotification.success(`Deleted ${currentAsset.asset.name} entry with key ${key}`))
            .catch(error => {
                globalNotification.error('Error:', error)
            })
            .finally(() => {
                window.location.reload()
            })
    }

    return (
        <div>
            {data !== null ? (
                Object.entries(data).map(([id, changes]) => (
                    <>
                        <StyledCardContainer
                            title={`${currentAsset.asset.name} ${type} -> ${isNaN(Number(id)) ? id : `ID ${id}`}`}
                            collapsed={collapsed}
                            renderControls={() => {
                                return (
                                    <Button onClick={() => setCollapsed(!collapsed)}>
                                        <i className={collapsed ? 'far fa-angle-up' : 'far fa-angle-down'} />
                                    </Button>
                                )
                            }}
                        >
                            <Table>
                                <HeadRow>
                                    <OrderingHeader>{type} Element</OrderingHeader>
                                    <OrderingHeader>Frozen By</OrderingHeader>
                                    <OrderingHeader>Date</OrderingHeader>
                                    <OrderingHeader>Time</OrderingHeader>
                                    <OrderingHeader>Previous Value</OrderingHeader>
                                    <OrderingHeader>Current Value</OrderingHeader>
                                    <OrderingHeader></OrderingHeader>
                                </HeadRow>
                                {Object.entries(changes).map(([changeKey, changeValue]) => (
                                    <BodyRow key={`${id}-${changeKey}`}>
                                        <div style={{ flexDirection: 'column' }}>
                                            <ul>
                                                {changeKey.split(':').map((part, index) => (
                                                    <li key={index}>{part.replace(/(\d+)$/, ' #$1')}</li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div>{changeValue.changedBy}</div>
                                        <div>{dateService.formatDate(changeValue.changedOn)}</div>
                                        <div>{dateService.formatTime(changeValue.changedOn)}</div>
                                        <div>{changeValue.changedFrom}</div>
                                        <div>{changeValue.changedTo}</div>
                                        <div>
                                            {canManageMetadata() && (
                                                <Button
                                                    variant="danger"
                                                    onClick={() =>
                                                        handleDelete(currentAsset.asset.id, id, changeKey, type)
                                                    }
                                                >
                                                    <i className="far fa-trash-alt" />
                                                    Unfreeze
                                                </Button>
                                            )}
                                        </div>
                                    </BodyRow>
                                ))}
                            </Table>
                        </StyledCardContainer>
                    </>
                ))
            ) : (
                <StyledEmptyData />
            )}
        </div>
    )
}

export default ChangeLog
